<template>
  <div class="tablenav-pages pagination-wrapper d-flex align-items-center">
    <span v-if="displayConfig.total" class="displaying-num">{{ query.total }} items</span>
    <a v-if="displayConfig.first" :class="`first-page btn btn-light ${query.page < 3 ? 'disabled' : ''}`" href="#" @click.stop.prevent="firstPage()">
      <i class="ti ti-chevrons-left"></i>
    </a>
    <a v-if="displayConfig.prev" :class="`prev-page btn btn-light ${query.page < 2 ? 'disabled' : ''}`" href="#" @click.stop.prevent="prevPage()">
      <i class="ti ti-chevron-left"></i>
    </a>
    <template v-if="displayConfig.input">
      <input class="current-page form-control" type="text" name="query.page" :value="page" size="2" aria-describedby="table-paging" @change.prevent="pageChange($event.target.value)" />
      <span class="tablenav-paging-text">
        of <span class="total-pages">{{ Math.ceil(query.total / query.limit) }}</span>
      </span>
    </template>
    <a v-if="displayConfig.next" :class="`next-page btn btn-light ${Math.ceil(query.total / query.limit) - query.page < 1 ? 'disabled' : ''}`" href="#" @click.stop.prevent="nextPage()">
      <i class="ti ti-chevron-right"></i>
    </a>
    <a v-if="displayConfig.last" :class="`last-page btn btn-light ${Math.ceil(query.total / query.limit) - query.page < 2 ? 'disabled' : ''}`" href="#" @click.stop.prevent="lastPage()">
      <i class="ti ti-chevrons-right"></i>
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    query() {
      return Object.assign(
        {
          total: 0,
          limit: 10,
          page: 1
        },
        this.config
      )
    },
    page() {
      return this.query.page
    },
    displayConfig() {
      return Object.assign(
        {
          total: true,
          first: true,
          last: true,
          input: true,
          next: true,
          prev: true
        },
        this.display
      )
    }
  },
  props: {
    config: Object,
    display: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    firstPage() {
      if (this.query.page > 2) {
        this.$emit('changeValue', 1)
      }
    },
    prevPage() {
      if (this.query.page > 1) {
        this.$emit('changeValue', this.query.page - 1)
      }
    },
    pageChange(page) {
      page = Math.max(1, Math.min(Math.ceil(this.query.total / this.query.limit), page))
      if (!(page > 0)) {
        page = this.query.page
      }
      this.$emit('changeValue', page)
    },
    nextPage() {
      if (Math.ceil(this.query.total / this.query.limit) - this.query.page > 0) {
        this.$emit('changeValue', this.query.page + 1)
      }
    },
    lastPage() {
      if (Math.ceil(this.query.total / this.query.limit) - this.query.page > 1) {
        this.$emit('changeValue', Math.ceil(this.query.total / this.query.limit))
      }
    }
  }
}
</script>
<style lang="scss">
.tablenav-pages {
  float: right;
  margin: 9px 0;
  .displaying-num {
    margin-right: 7px;
  }
  .tablenav-paging-text,
  .current-page {
    width: auto;
    margin: 0 0 0 3px;
    font-size: 13px;
    text-align: center;
  }
  .btn,
  .tablenav-pages-navspan {
    width: 38px;
    height: 38px;
    margin: 0 0 0 3px;
    padding: 0 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
      font-size: 16px;
      line-height: 1.625;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
    }
  }
}
</style>
